<script>
import { storagePath } from '@/shared/js/utils/index'

/**
 * Generates a Hypefactors Icon
 * @module VIcon
 */
export default {
  name: 'VIcon',

  functional: true,

  props: {
    type: {
      type: String,
      required: true
    },
    even: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: ''
    },
    fallback: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    }
  },

  render: (h, { data, props }) => {
    const icon = h('i', {
      ...data,
      class: [
        'hf',
        data.class,
        data.staticClass,
        {
          'hf-fw': props.even,
          ['hf-' + props.size]: props.size,
          ['hf-' + props.type]: props.type
        }
      ]
    })

    const imageSrc = storagePath('/images/icons/hf_font/' + props.type + '.svg')

    // 2. If fallback is true AND a color is provided, use CSS Masking
    if (props.fallback && props.color) {
      return h('div', {
        ...data,
        class: [
          'v-icon-fallback-mask',
          'v-icon-fallback-dimension',
          data.class,
          data.staticClass
        ],
        style: {
          ...data.style,
          backgroundColor: props.color,
          WebkitMaskImage: `url(${imageSrc})`,
          maskImage: `url(${imageSrc})`,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          display: 'inline-block',

          // Only add inline styles if explicit attributes (width="20") are present.
          // Otherwise, we rely on the CSS class 'v-icon-fallback-dimension'.
          ...(data.attrs && data.attrs.width ? { width: `${data.attrs.width}px` } : {}),
          ...(data.attrs && data.attrs.height ? { height: `${data.attrs.height}px` } : {})
        }
      })
    }

    const image = h('img', {
      ...data,
      attrs: { ...data.attrs, src: imageSrc },
      class: [
        'v-icon-fallback',
        data.class,
        data.staticClass
      ]
    })

    return props.fallback ? image : icon
  }

}
</script>
